import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux'
import Collapse from 'react-bootstrap/Collapse';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';

import { deleteStencil } from 'product_tabs/tab_smt_stencils/stencilSlice';
import sides from 'product_tabs/tab_smt_stencils/data/StencilsSides';
import { getStencilsTitle } from 'product_tabs/tab_smt_stencils/utils/helpers';

const Stencils = ({ subTotal, quantity, selected }) => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const {
    stencilsType,
    stencilsSide,
  } = useSelector((state) => state.smtStencil);

  if (!selected) return null;

  const selectedStencilInfo = Spree.stencils_info.find((info) => info.slug === stencilsType);
  const stencilsTypeDesc = selectedStencilInfo ? selectedStencilInfo.name : stencilsType;

  const selectedStencilSide = sides.find((side) => side.key === stencilsSide);
  const stencilsSideDesc = selectedStencilSide ? selectedStencilSide.label : stencilsSide;

  const onDelete = () => {
    dispatch(deleteStencil())
    setOpen(false);
  };
  const onToggle = () => setOpen(!open);

  return (
    <div className="cart-section stencils">
      <div className="title">
        {getStencilsTitle(stencilsSide)} SMT Stencils
        {quantity !== undefined ? ` X ${quantity}` : null}

        <button type="button" onClick={onDelete} className="btn btn-link float-end btn-delete">
          <FontAwesomeIcon icon={faTrashCan} />
        </button>
      </div>
      <div className="position-relative">
        <div className="price">
          {subTotal === undefined ? null : `$${subTotal}`}
        </div>
        <div className="toggle-details">
          <button type="button" className="btn btn-link p-0" onClick={onToggle}>
            {`${open ? 'LESS' : 'VIEW MORE'}`} 
          </button>
        </div>
        <Collapse in={open}>
          <div>
            <div className="details">
              <div className="detail">
                <strong>Type:</strong> {stencilsTypeDesc}
              </div>
              <div className="detail">
                <strong>Sides:</strong> {stencilsSideDesc}
              </div>
            </div>
          </div>
        </Collapse>
      </div>

    </div>
  )
};

Stencils.propTypes = {
  subTotal: PropTypes.number,
  quantity: PropTypes.number,
  selected: PropTypes.bool,
}

export default Stencils;
